import PageErrorIcon from "../../assets/svg/PageErrorIcon";
import CustomText from "../atomic/CustomText";
import CustomImageViewer from "../molecular/CustomImageViewer";
import Button from "../organism/Button";

function sendEmail() {
  window.location.href = "mailto:clinicalservices@castlebiosciences.com";
}

function ErrorFallBack({ className }: { className?: string }): JSX.Element {
  return (
    <div
      className={`flex flex-col justify-center items-center w-full h-full text-royalBlue text-center px-5 ${className}`}
    >
      <CustomImageViewer
        imageTitle="Section Error"
        imageUrl={require("../../assets/images/ErrorIcon.png")}
        className="object-contain !h-20 !w-20 bg-transparent border-none"
      />
      <CustomText
        text="Failed to access this section"
        fontWeight="font-semibold"
        fontSize="text-2xl"
        className="my-4 capitalize"
      />
      <Button
        textInformation={{
          text: "contact support",
          fontWeight: "font-bold",
        }}
        onClick={sendEmail}
        buttonTheme="secondary"
      />
    </div>
  );
}

export default ErrorFallBack;
